import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-overall-sentiment-meh-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfOverallSentimentMehIconProps extends SvgIconProps  {}

/**
 * Component to render overall sentiment icon for intermediate score in RTIG
 * @param props - CcfOverallSentimentMehIconProps
 * @example <CcfOverallSentimentMehIcon />
 * @returns 
 */
export function CcfOverallSentimentMehIcon(
  props: CcfOverallSentimentMehIconProps
) {
  return (
    <SvgIcon
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      {...props}
    >
      <path
        d="M9.23001 11.867C9.49088 11.867 9.74589 11.7896 9.9628 11.6447C10.1797 11.4998 10.3488 11.2938 10.4486 11.0528C10.5484 10.8117 10.5746 10.5465 10.5237 10.2907C10.4728 10.0348 10.3471 9.79979 10.1627 9.61533C9.97821 9.43086 9.74319 9.30524 9.48733 9.25434C9.23147 9.20345 8.96626 9.22957 8.72525 9.3294C8.48423 9.42923 8.27823 9.59829 8.1333 9.8152C7.98836 10.0321 7.91101 10.2871 7.91101 10.548C7.91101 10.8978 8.04997 11.2333 8.29733 11.4807C8.54469 11.728 8.88019 11.867 9.23001 11.867ZM13.186 0C10.5781 0 8.02868 0.773346 5.86026 2.22224C3.69183 3.67114 2.00175 5.73051 1.00373 8.13994C0.0057134 10.5494 -0.255414 13.2006 0.253371 15.7585C0.762156 18.3163 2.018 20.6658 3.8621 22.5099C5.70619 24.354 8.05571 25.6098 10.6135 26.1186C13.1714 26.6274 15.8226 26.3663 18.2321 25.3683C20.6415 24.3703 22.7009 22.6802 24.1498 20.5117C25.5987 18.3433 26.372 15.7939 26.372 13.186C26.372 9.68886 24.9828 6.33494 22.5099 3.86209C20.0371 1.38924 16.6832 0 13.186 0ZM13.186 23.734C11.0995 23.7342 9.05985 23.1157 7.32492 21.9566C5.58999 20.7975 4.23774 19.15 3.43919 17.2224C2.64064 15.2948 2.43165 13.1736 2.83865 11.1272C3.24566 9.08084 4.25037 7.20109 5.72574 5.72573C7.2011 4.25037 9.08084 3.24565 11.1272 2.83865C13.1736 2.43164 15.2948 2.64063 17.2224 3.43919C19.15 4.23774 20.7975 5.58999 21.9566 7.32491C23.1157 9.05984 23.7342 11.0995 23.734 13.186C23.7337 15.9834 22.6224 18.6662 20.6443 20.6443C18.6662 22.6223 15.9834 23.7337 13.186 23.734ZM17.142 9.234C16.8811 9.234 16.6261 9.31136 16.4092 9.45629C16.1923 9.60122 16.0232 9.80723 15.9234 10.0482C15.8236 10.2893 15.7975 10.5545 15.8484 10.8103C15.8992 11.0662 16.0249 11.3012 16.2093 11.4857C16.3938 11.6701 16.6288 11.7958 16.8847 11.8467C17.1405 11.8975 17.4057 11.8714 17.6468 11.7716C17.8878 11.6718 18.0938 11.5027 18.2387 11.2858C18.3836 11.0689 18.461 10.8139 18.461 10.553C18.4615 10.3795 18.4278 10.2075 18.3618 10.047C18.2957 9.88652 18.1986 9.74064 18.0761 9.61774C17.9536 9.49483 17.808 9.39732 17.6477 9.33078C17.4874 9.26425 17.3156 9.23 17.142 9.23V9.234Z"
        fill="url(#paint0_angular_134_1144)"
      />
      <path
        d="M18.183 18.066H8.18298"
        stroke="url(#paint1_linear_134_1144)"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <defs>
        <radialGradient
          id="paint0_angular_134_1144"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.186 13.186) rotate(46.6416) scale(86.393)"
        >
          <stop offset="0.510417" stopColor="#FF2B53" />
          <stop offset="0.643012" stopColor="#FAA53C" />
          <stop offset="0.827495" stopColor="#F1AC56" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_134_1144"
          x1="13.183"
          y1="18.066"
          x2="13.183"
          y2="19.066"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.380108" stopColor="#FF2B53" />
          <stop offset="0.541667" stopColor="#FAA53C" />
          <stop offset="0.90625" stopColor="#F1AC56" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
}

export default CcfOverallSentimentMehIcon;
